var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import styled from 'styled-components';
import useWindowSize from '../../customHooks/useWindowWidth';
import query from '../../../const/mediaQueries';
import filterUndefined from '../../../helpers/filterUndefined';
export function getFlexDirection(direction, radioType, windowSize) {
    if (radioType === 'chip' && windowSize.isLessThanTablet) {
        return 'column';
    }
    return direction;
}
const RadioContainer = styled.fieldset `
  border: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  margin-top: auto;
  flex-direction: ${({ direction }) => direction};

  .sr-only {
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  ${({ direction, radioType }) => {
    if (direction === 'column' && radioType === 'chip') {
        return `
        @media ${query.lessThanMedium} {
          width: 100%;
        }
      `;
    }
    return '';
}};
`;
const Legend = ({ dataCy, hideLegend, legend = React.createElement(React.Fragment, null) }) => typeof legend === 'string' ? (React.createElement("legend", { className: hideLegend && 'sr-only', "data-cy": dataCy && `${dataCy}.legend` }, legend)) : (cloneElement(legend, {
    className: [legend.props.className, hideLegend && 'sr-only']
        .filter(Boolean)
        .join(' ')
}));
const RadioGroup = (_a) => {
    var { legend, hideLegend, selected, onChange = () => { }, children, className, direction = 'column', radioType, dataCy } = _a, props = __rest(_a, ["legend", "hideLegend", "selected", "onChange", "children", "className", "direction", "radioType", "dataCy"]);
    const windowWidth = useWindowSize();
    const flexDirection = getFlexDirection(direction, radioType, windowWidth);
    /**
     * For conditional Radio rendering, the RadioGroup fails to render
     * when render condition is set to `false`. This is due to the array
     * having an undefined value in the place of that element.
     * To fix the problem we need to filter the children array
     * from the non truthy values below.
     */
    const filteredChildren = filterUndefined(children);
    return (React.createElement(RadioContainer, Object.assign({}, props, { radioType: radioType, direction: flexDirection, className: className, "data-cy": dataCy, role: "radiogroup" }),
        React.createElement(Legend, { hideLegend: hideLegend, legend: legend, dataCy: dataCy }),
        Children.map(filteredChildren, (child) => cloneElement(child, Object.assign(Object.assign({}, child.props), { checked: selected === child.props.value, direction,
            radioType, onChange: () => onChange(child.props.value) })))));
};
export default RadioGroup;
